import {
  getOutboundInboundCompanyAndRouteParams,
  getOutboundInboundIdParams,
} from '@/app/components/hotel-detail/common/tracking';

export const FLIGHT_CLICKED = 'FLIGHT_CLICKED';
export const FLIGHT_CLICKED_VERSION = '1.3';

export type FlightClickedPayload = {
  inboundAirlineId: string;
  inboundFlightId: string;
  inboundRouteId: string;
  outboundAirlineId: string;
  outboundFlightId: string;
  outboundRouteId: string;
  productDetailKey: string;
  searchId: string;
  wasDefaultFlight: boolean;
  flightClickId: string;
  vcSearchId: string;
};

export type FlightClickedParams = {
  searchId: string;
  productDetailKey: string;
  wasDefaultFlight: boolean;
  transport: Pick<TransportsType, 'outbound' | 'inbound'>;
  flightClickId: string;
  vcSearchId: string;
};

export const createFlightClickedPayload = (params: FlightClickedParams): FlightClickedPayload => {
  const { searchId, productDetailKey, wasDefaultFlight, transport, flightClickId, vcSearchId } = params;

  return {
    searchId,
    productDetailKey,
    wasDefaultFlight,
    ...getOutboundInboundIdParams(transport.outbound, transport.inbound),
    ...getOutboundInboundCompanyAndRouteParams(transport.outbound, transport.inbound),
    flightClickId,
    vcSearchId,
  };
};
